// HOOKS
import useSelected from "../../hooks/other/useSelected.other.hook";
import useColumns from "../../hooks/other/useColumns.other.hook";
import useSelectAll from "../../hooks/other/useSelectAll.other.hook";
import { useContext, useEffect } from "react";

// CONTEXTS
import { ShipmentsContext } from "../../contexts/shipments/shipments.context";

// COMPONENTS
import Refresh from "../../components/refresh/refresh.component";
import Spinner from "../../components/spinner/spinner.component";
import { shippingColumns } from "../../assets/variables/columns/shipping.columns";
import Table from "../../components/tables/customizableTable/table.customizableTable";
import GetShipmentFormProps from "../../components/formProps/shipments/shipment.formProp";
import PaginationBar from "../../components/tables/customizableTable/features/pagination/paginationBar";
import QueryContainer from "../../components/tables/query/queryContainer.table.component";
import ShipmentInfoBar from "../../components/infoBar/shipments/shipment.infoBar";

const CLASSNAMES = {
  pagination: {
    arrow:
      "active:shadow-inner active:shadow-black bg-lightPrimary hover:bg-lightSecondary shadow shadow-black hover:cursor-pointer hover:dark:bg-darkSecondary dark:bg-darkPrimary dark:fill-white rounded-md w-8 h-8",
    currentPage:
      "shadow-inner shadow-black dark:bg-darkSecondary bg-lightSecondary dark:text-white text-white hover:cursor-pointer rounded h-8 w-8 flex items-center justify-center",
    page: "active:shadow-inner active:shadow-black shadow shadow-black hover:dark:bg-darkSecondary hover:bg-lightSecondary active:shadow-inner dark:text-white text-white dark:bg-darkPrimary bg-lightPrimary hover:cursor-pointer rounded h-8 w-8 flex items-center justify-center",
  },
  columnFilter: {
    dropdownButton: {
      dropdown:
        "border-animate rounded h-[250px] w-[250px] overflow-y-scroll absolute backdrop-blur-sm bg-greenGlass flex flex-col gap-1 p-2 top-11 z-50",
    },
  },
  limit: {
    dropdownButton: {
      dropdown:
        "border-animate rounded absolute backdrop-blur-sm bg-greenGlass flex flex-col gap-1 p-2 top-11 z-50",
    },
  },
  spinner: {
    container: "flex w-full h-full justify-center items-center",
    spinner:
      "shadow animate-spin border-dashed rounded-full h-16 w-16 border-2 border-primary",
  },
  statusFilter: {
    dropdownButton: {
      dropdown:
        "w-[225px] border-animate rounded overflow-y-auto absolute backdrop-blur-sm bg-greenGlass flex flex-col gap-1 p-2 top-11 z-50",
    },
  },
};

const ShippingPage = () => {
  const { selected, setSelected, removeSelected, resetSelected, addSelected } =
    useSelected();
  const { selectAll, handleSelectAll, resetSelectAll } = useSelectAll();
  const { columns, setColumns, handleColumnFilterCheck, handleResize } =
    useColumns(shippingColumns); // Set default columns
  const {
    shipments,
    metaData,
    getShipments,
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    isLoading,
    handleChange,
    shipmentInput,
    setShipmentInput,
    handleMultiSelectChange,
  } = useContext(ShipmentsContext);
  const { page, limit, sort, search } = query;

  // Fetch shipments on page load
  useEffect(() => {
    getShipments();
  }, []);

  const changeHandlers = {
    handleChange,
    handleMultiSelectChange,
    handleSearch,
  };

  return (
    <div
      style={{ height: "calc(100vh - 136px" }}
      className="p-4 flex flex-col gap-2 overflow-y-hidden"
    >
      <h1 className="font-ubuntuBold text-lg items-center text-center">
        Shipping
      </h1>
      <div className="flex flex-row justify-between">
        <QueryContainer
          queryProps={{
            search: {
              search,
              handleChange: handleSearch,
            },
            limit: {
              handleChange: handleLimitChange,
              limit,
            },
            columnFilter: {
              handleChange: handleColumnFilterCheck,
              columns,
            },
          }}
          classNames={{
            limit: CLASSNAMES.limit,
            columnFilter: CLASSNAMES.columnFilter,
          }}
        ></QueryContainer>
        {/* <ShipmentActionBar /> */}
      </div>
      <div className="p-2">
        <PaginationBar
          metaData={metaData}
          currentPage={page}
          totalPages={metaData?.totalPages || 1}
          handleChange={handlePageChange}
          classNames={CLASSNAMES.pagination}
        />
      </div>
      <div className="flex flex-row justify-between">
        <ShipmentInfoBar metaData={metaData} />
        <Refresh minimumValue={30} handleEvent={getShipments} />
      </div>
      <div className="flex items-center justify-start overflow-hidden w-full h-full">
        <div
          className={`rounded relative ${
            isLoading ? "w-full" : "overflow-x-auto"
          } h-full px-1 pb-8`}
        >
          {(isLoading || !shipments?.length > 0) && (
            <div className=" shadow shadow-black rounded z-20 bg-gray-300/35 backdrop-blur-sm absolute w-full h-full flex justify-center items-center">
              <Spinner classNames={CLASSNAMES.spinner} />
            </div>
          )}
          <Table
            metaData={metaData}
            columnProps={{ columns, handleResize }}
            sortProps={{ sort, handleSort }}
            options={{ select: false }}
            changeHandlers={changeHandlers}
            getFormProps={GetShipmentFormProps}
            defaultColumns={shippingColumns}
            data={shipments}
            select={false}
          />
        </div>
      </div>
    </div>
  );
};

export default ShippingPage;
